import { usePage } from '@inertiajs/react';

import { cmsPagesEditorIndexPath } from '@/lib/routes';

export function useIsPageEditor(): boolean {
  const { url } = usePage();
  return url === cmsPagesEditorIndexPath() || url.startsWith(cmsPagesEditorIndexPath());
}
